<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>系统配置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">配置列表</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="属性名">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入属性名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <!-- <el-button
          type="primary"
          class="btn"
          style="margin-bottom: 16px;"
          @click="add()"
          >添加</el-button
        > -->
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column prop="sort" label="排序" align="center">
          </el-table-column>
          <el-table-column prop="propName" label="属性名" align="center">
          </el-table-column>
          <el-table-column prop="propValue" label="值" align="center">
          </el-table-column>
          <el-table-column prop="propDesc" label="属性描述" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <div class="disAround">
                <div class="operateBtn" @click="handleEdit(scope.row)">
                  编辑
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="600px">
      <el-form
        label-position="right"
        :model="ruleForm1"
        :rules="rules"
        ref="ruleForm"
        style="margin: 0 auto"
      >
        <el-form-item label="属性" prop="key">
          <el-input
            v-model="ruleForm1.key"
            placeholder="请输入属性名称"
            style="width: 280px"
          ></el-input>
        </el-form-item>
        <el-form-item label="值" prop="val">
          <el-input
            v-model="ruleForm1.val"
            placeholder="请输入属性值"
            style="width: 280px"
          ></el-input>
        </el-form-item>
        <el-form-item label="属性描述" prop="memo">
          <el-input
            v-model="ruleForm1.memo"
            placeholder="请输入属性描述"
            style="width: 280px"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="memo">
          <el-input
            v-model="ruleForm1.sort"
            placeholder="请输入排序"
            style="width: 280px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetForm1('ruleForm')">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.systemData(),
      ruleForm: {
        name: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      title: "",
      ruleForm1: {
        key: "",
        val: "",
        memo: "",
      },
      rules: {
        key: [{ required: true, message: "必填项", trigger: "blur" }],
        val: [{ required: true, message: "必填项", trigger: "blur" }],
      },
      editId: "",
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            propValue: this.ruleForm1.val,
            propName: this.ruleForm1.key,
            propDesc: this.ruleForm1.memo,
            sort: this.ruleForm1.sort,
          };
          if (this.editId == "") {
            // this.$axios
            //   .post(`/admapi/division/add`, param)
            //   .then(({ data }) => {
            //     this.$message({
            //       message: "添加成功",
            //       type: "success"
            //     });
            //     this.getList();
            //   })
            //   .catch()
            //   .finally((this.dialogFormVisible = false));
          } else {
            param.id = this.editId;
            this.$axios
              .post(`/admapi/sys/conf/update/${this.editId}`, param)
              .then(({ data }) => {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.getList();
              })
              .catch()
              .finally(() => {
                this.dialogFormVisible = false;
                this.editId = "";
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm1(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    resetForm() {
      this.ruleForm.name = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    // add() {
    //   this.dialogFormVisible = true;
    //   this.title = "添加配置";
    //   this.editId = "";
    // },
    handleEdit(val) {
      this.dialogFormVisible = true;
      this.title = "编辑配置";
      this.editId = val.id;
      this.ruleForm1.key = val.propName;
      this.ruleForm1.val = val.propValue;
      this.ruleForm1.memo = val.propDesc;
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        queryParams: [],
      };
      if (this.ruleForm.name != "") {
        param.queryParams.push({
          name: "prop_name",
          type: "input",
          value: this.ruleForm.name,
        });
      }
      this.$axios
        .post(`/admapi/sys/conf/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped></style>
